import type { KibanaLogger } from '@revelio/iso-utility';

import { submitDataBuilderPayload } from '../../api/data-builder-api';
import type { DataBuilderPayload } from '../../api/data-builder-api.types';

export const submitDeliverableWithLogging = async (
  payload: DataBuilderPayload,
  kibanaLogger: KibanaLogger | undefined,
  // Optional call-site identity preserved in the Kibana log so existing
  // monitors / alerts that filter on a specific context (e.g.
  // `DataBuilder.useVerifySubmit`) keep matching after the helper extraction.
  context = 'DataBuilder.submitDeliverable'
): Promise<void> => {
  try {
    await submitDataBuilderPayload(payload);
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    kibanaLogger?.error(
      `Data Builder: submit against backend failed: ${errorMessage}`,
      {
        url: window.location.href,
        context,
      }
    );
    throw error;
  }
};
